import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {SubscribersService, TokenStorageService} from '@coreServices';
import {AuthService} from '@coreApiServices';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ConfirmModalComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() confirmationButtonText?: string = "Confirm";
  @Input() cancelButtonText?: string = "Cancel";
  @Input() isDeactivateAccount !: any
  @Input() isAlert!: boolean;
  private destroy$ = new Subject<void>();

  constructor(public activeModal: NgbActiveModal,
              private tokenStorageService: TokenStorageService,
              private subscriberService: SubscribersService,
              private authService: AuthService,
              public router: Router,
  ) {
  }

  clearToken() {
    this.activeModal.close();
    this.authService.logout().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.tokenStorageService.clearStorage();
      this.subscriberService.isUserLoggedIn.next(false);
      this.router.navigate(['/']);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
